import Button from "../../../components/Button";
import Excel from "../../../assets/icons/Excel";
import { DownloadExcel } from "../../../modules/serviceRegister/api";
import config from "../../../config";
import { useUrlSearchParams } from "use-url-search-params";
import { useState } from "react";

const ExcelDownload = ({ defaultParams }) => {
    const [loading, setLoading] = useState(false);

    const paramsWithDefaults = {
        page: defaultParams?.page
              ? defaultParams.page - 1
              : 0,
        perPage: defaultParams?.perPage || config.perPage,
        sort: {
            name: defaultParams?.sort?.name || "id",
            direction: defaultParams?.sort?.direction || "desc",
        },
        filter: (defaultParams?.filter || []).filter(i => !!i.value),
    };

    const handleDownload = async () => {
        setLoading(true);
        try {
            const data = await DownloadExcel({
                params: paramsWithDefaults,
            })
            const blob = new Blob([data.data]);

            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");

            link.href = url;
            link.setAttribute("download", "service_register.xlsx");
            document.body.appendChild(link);

            link.click();
            link.parentElement.removeChild(link)
            window.URL.revokeObjectURL(url);
        }
        catch (e) {
            console.error(e);
        }
        finally {
            setLoading(false);
        }
    };
    return (
        <Button
            background="blue"
            color="white"
            border="blue"
            radius="sm"
            disabled={loading}
            onClick={() => handleDownload()}
        >
            <Excel/>
            Excel yuklash
        </Button>
    )
}

export default ExcelDownload;
